var _excluded = ["fixedHeader", "noHeader", "scroll", "footer", "footerClassName", "footerStyle", "bodyClassName", "bodyStyle", "rowClassName", "onRow", "onHead", "renderEmpty", "emptyText", "rowKey", "datasource", "dataPropsMapping", "data", "columns", "rowExpandTrigger", "renderExpand", "renderExpandHeight", "expandedRowKeys", "onExpandedRowChange", "expandOptions", "treeOptions", "rowSelection", "selectOptions", "filters", "sorter", "multipleSorter", "pager", "onChange", "onStateChange", "internalProcess", "filterOptions", "sortOptions", "paginationOptions"],
    _excluded2 = ["active"],
    _excluded3 = ["page", "pageSize", "total", "defaultPage"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Fragment, useMemo, useRef } from 'react';
import { classnames, isFunction, isObject } from '@okee-uikit/react-utils';
import { useConstCallback, useRefCallback } from '@okee-uikit/react-hooks';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { convertColumn } from '../../units/table/util/column';
import { PureTable } from '../pure-table';
import { Empty } from '../empty';
import { Pager } from '../pager/Pager';
import { TableContextProvider } from './hooks/table';
import { useTableRowsInit } from './hooks/row-info';
import { useTableColumnsInit } from './hooks/column';
import { useTableFilterInit } from './hooks/filter';
import { useTableSortInit } from './hooks/sort';
import { useTableExpansionInit, useTableTreeInit } from './hooks/active';
import { useTableSelectionInit } from './hooks/selection';
import { useTablePaginationInit } from './hooks/pagination';
var Head = PureTable.Head,
    Body = PureTable.Body,
    RowGroup = PureTable.RowGroup,
    ScrollerBar = PureTable.ScrollerBar;
export function Table(props) {
  var _props$fixedHeader = props.fixedHeader,
      fixedHeader = _props$fixedHeader === void 0 ? false : _props$fixedHeader,
      _props$noHeader = props.noHeader,
      noHeader = _props$noHeader === void 0 ? false : _props$noHeader,
      scroll = props.scroll,
      footer = props.footer,
      footerClassName = props.footerClassName,
      footerStyle = props.footerStyle,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      rowClassName = props.rowClassName,
      onRow = props.onRow,
      onHead = props.onHead,
      renderEmpty = props.renderEmpty,
      emptyText = props.emptyText,
      rowKey = props.rowKey,
      datasource = props.datasource,
      _props$dataPropsMappi = props.dataPropsMapping,
      dataPropsMapping = _props$dataPropsMappi === void 0 ? {} : _props$dataPropsMappi,
      _props$data = props.data,
      data = _props$data === void 0 ? datasource !== null && datasource !== void 0 ? datasource : [] : _props$data,
      propColumns = props.columns,
      rowExpandTrigger = props.rowExpandTrigger,
      renderExpand = props.renderExpand,
      renderExpandHeight = props.renderExpandHeight,
      expandedRowKeys = props.expandedRowKeys,
      onExpandedRowChange = props.onExpandedRowChange,
      propExpandOptions = props.expandOptions,
      treeOptions = props.treeOptions,
      rowSelection = props.rowSelection,
      propSelectOptions = props.selectOptions,
      filters = props.filters,
      sorter = props.sorter,
      _props$multipleSorter = props.multipleSorter,
      multipleSorter = _props$multipleSorter === void 0 ? false : _props$multipleSorter,
      _props$pager = props.pager,
      pager = _props$pager === void 0 ? false : _props$pager,
      propOnChange = props.onChange,
      propOnStateChange = props.onStateChange,
      _props$internalProces = props.internalProcess,
      internalProcess = _props$internalProces === void 0 ? false : _props$internalProces,
      _props$filterOptions = props.filterOptions,
      propFilterOptions = _props$filterOptions === void 0 ? false : _props$filterOptions,
      _props$sortOptions = props.sortOptions,
      propSortOptions = _props$sortOptions === void 0 ? false : _props$sortOptions,
      _props$paginationOpti = props.paginationOptions,
      propPaginationOptions = _props$paginationOpti === void 0 ? false : _props$paginationOpti,
      extra = _objectWithoutProperties(props, _excluded);

  var defaultEmptyText = useLocale('table.emptyText');
  var renderEmptyCallback = useRefCallback(renderEmpty);
  var onStateChange = useRefCallback(function (state) {
    propOnStateChange === null || propOnStateChange === void 0 ? void 0 : propOnStateChange(state);
    propOnChange === null || propOnChange === void 0 ? void 0 : propOnChange({
      filters: state.filterState,
      sorter: state.sortState,
      page: state.page,
      pageSize: state.pageSize
    });
  });
  var stateRef = useRef({
    filterState: {},
    sortState: [],
    page: 1,
    pageSize: 10
  });
  var onPageChange = useConstCallback(function (page) {
    onStateChange(_objectSpread(_objectSpread({}, stateRef.current), {}, {
      page: page
    }));
  });
  var onPageSizeChange = useConstCallback(function (pageSize) {
    onStateChange(_objectSpread(_objectSpread({}, stateRef.current), {}, {
      pageSize: pageSize
    }));
  });
  var onSorterChange = useConstCallback(function (sortState) {
    onStateChange(_objectSpread(_objectSpread({}, stateRef.current), {}, {
      sortState: sortState
    }));
  });
  var onFilterChange = useConstCallback(function (filterState) {
    onStateChange(_objectSpread(_objectSpread({}, stateRef.current), {}, {
      filterState: filterState,
      page: 1
    }));
  });
  var selectOptions = useMemo(function () {
    if (propSelectOptions) {
      return propSelectOptions;
    }

    if (rowSelection) {
      var columnWidth = rowSelection.columnWidth,
          columnTitle = rowSelection.columnTitle,
          fixed = rowSelection.fixed,
          _align = rowSelection.align,
          valign = rowSelection.valign,
          type = rowSelection.type,
          selectedRowKeys = rowSelection.selectedRowKeys,
          _onChange = rowSelection.onChange,
          getCheckboxProps = rowSelection.getCheckboxProps;

      if (type === 'radio') {
        var singleOptions = {
          type: 'single',
          value: selectedRowKeys === null || selectedRowKeys === void 0 ? void 0 : selectedRowKeys[0],
          onChange: function onChange(newValue) {
            return _onChange === null || _onChange === void 0 ? void 0 : _onChange(newValue && [newValue] || []);
          },
          width: columnWidth,
          title: columnTitle,
          align: _align,
          valign: valign,
          fixed: fixed && 'left'
        };
        return singleOptions;
      }

      var multipleOptions = {
        type: 'multiple',
        value: selectedRowKeys,
        onChange: _onChange,
        width: columnWidth,
        title: columnTitle,
        align: _align,
        valign: valign,
        fixed: fixed && 'left',
        componentProps: function componentProps(info) {
          var _ref = (getCheckboxProps === null || getCheckboxProps === void 0 ? void 0 : getCheckboxProps(info)) || {},
              className = _ref.className,
              disabled = _ref.disabled;

          return {
            className: className,
            disabled: disabled
          };
        }
      };
      return multipleOptions;
    }

    return undefined;
  }, [propSelectOptions, rowSelection]);

  var _useTableSelectionIni = useTableSelectionInit(selectOptions),
      _useTableSelectionIni2 = _slicedToArray(_useTableSelectionIni, 3),
      selected = _useTableSelectionIni2[0],
      selectionActions = _useTableSelectionIni2[1],
      selectionColumn = _useTableSelectionIni2[2];

  var idProp = dataPropsMapping.id || rowKey || 'id';
  var childrenProp = dataPropsMapping.children || 'children';
  var getId = useRefCallback(isFunction(idProp) && idProp || function (row, index) {
    var _a;

    return (_a = row[idProp]) !== null && _a !== void 0 ? _a : index;
  });
  var getChildren = useRefCallback(isFunction(childrenProp) && childrenProp || function (row) {
    return row[childrenProp];
  });
  var original = useTableRowsInit(data, {
    getId: getId,
    getChildren: getChildren
  }, selectOptions);
  var current = original;
  var treeActive;
  var treeActions;
  {
    var _useTableTreeInit = useTableTreeInit(treeOptions, current);

    var _useTableTreeInit2 = _slicedToArray(_useTableTreeInit, 2);

    treeActive = _useTableTreeInit2[0];
    treeActions = _useTableTreeInit2[1];
  }
  var expandOptions = useMemo(function () {
    if (propExpandOptions) {
      return propExpandOptions;
    }

    if (renderExpand) {
      var _content = function _content(info) {
        var expanded = info.active,
            extra = _objectWithoutProperties(info, _excluded2);

        return renderExpand(info.row, _objectSpread({
          expanded: expanded
        }, extra), function (value) {
          return value ? info.activate() : info.inactivate();
        });
      };

      if (rowExpandTrigger) {
        var expandedRows = rowExpandTrigger.expandedRows,
            onExpandedRowsChange = rowExpandTrigger.onExpandedRowsChange;
        return {
          value: expandedRows,
          onChange: onExpandedRowsChange,
          content: _content
        };
      }

      return {
        value: expandedRowKeys,
        onChange: onExpandedRowChange,
        content: _content
      };
    }
  }, [propExpandOptions, renderExpand]);

  var _useTableExpansionIni = useTableExpansionInit(expandOptions),
      _useTableExpansionIni2 = _slicedToArray(_useTableExpansionIni, 2),
      expansionActive = _useTableExpansionIni2[0],
      expansionActions = _useTableExpansionIni2[1];

  var aggregatedColumns = useMemo(function () {
    return selectionColumn && [selectionColumn].concat(_toConsumableArray(propColumns)) || propColumns;
  }, [propColumns, selectionColumn]);

  var _useTableColumnsInit = useTableColumnsInit(aggregatedColumns),
      columns = _useTableColumnsInit.columns;

  var filterOptions = useMemo(function () {
    if (isObject(propFilterOptions)) {
      var _onChange2 = propFilterOptions.onChange;
      return _objectSpread(_objectSpread({
        process: internalProcess
      }, propFilterOptions), {}, {
        onChange: function onChange(v, e) {
          _onChange2 === null || _onChange2 === void 0 ? void 0 : _onChange2(v, e);
          onFilterChange(v);
        }
      });
    }

    if (filters) {
      return {
        process: internalProcess,
        value: filters,
        onChange: onFilterChange
      };
    }

    if (propFilterOptions) {
      return {
        process: internalProcess
      };
    }

    return undefined;
  }, [internalProcess, propFilterOptions, filters]);

  var _useTableFilterInit = useTableFilterInit(current, columns, filterOptions),
      _useTableFilterInit2 = _slicedToArray(_useTableFilterInit, 3),
      filteredRows = _useTableFilterInit2[0],
      filterState = _useTableFilterInit2[1],
      filterActions = _useTableFilterInit2[2];

  current = filteredRows;
  var sortOptions = useMemo(function () {
    if (isObject(propSortOptions)) {
      var _onChange3 = propSortOptions.onChange;
      return _objectSpread(_objectSpread({
        process: internalProcess
      }, propSortOptions), {}, {
        onChange: function onChange(v, e) {
          _onChange3 === null || _onChange3 === void 0 ? void 0 : _onChange3(v, e);
          onSorterChange(v);
        }
      });
    }

    if (sorter) {
      return {
        process: internalProcess,
        value: sorter,
        onChange: onSorterChange,
        type: multipleSorter && 'multiple' || 'single',
        sortAs: multipleSorter === 'pre-selection-first' && 'push' || multipleSorter === 'post-selection-first' && 'unshift' || undefined
      };
    }

    if (propSortOptions) {
      return {
        process: internalProcess
      };
    }

    return undefined;
  }, [internalProcess, propSortOptions, sorter]);

  var _useTableSortInit = useTableSortInit(current, columns, sortOptions),
      _useTableSortInit2 = _slicedToArray(_useTableSortInit, 3),
      sortedRows = _useTableSortInit2[0],
      sortState = _useTableSortInit2[1],
      sortActions = _useTableSortInit2[2];

  current = sortedRows;
  var paginationOptions = useMemo(function () {
    if (isObject(propPaginationOptions)) {
      var _onChange4 = propPaginationOptions.onChange,
          _onSizeChange = propPaginationOptions.onSizeChange;
      return _objectSpread(_objectSpread({
        process: internalProcess
      }, propPaginationOptions), {}, {
        onChange: function onChange(v, e) {
          _onChange4 === null || _onChange4 === void 0 ? void 0 : _onChange4(v, e);
          onPageChange(v);
        },
        onSizeChange: function onSizeChange(v, e) {
          _onSizeChange === null || _onSizeChange === void 0 ? void 0 : _onSizeChange(v, e);
          onPageSizeChange(v);
        }
      });
    }

    if (pager) {
      var page = pager.page,
          pageSize = pager.pageSize,
          total = pager.total,
          defaultPage = pager.defaultPage,
          paginationProps = _objectWithoutProperties(pager, _excluded3);

      return {
        process: internalProcess,
        value: page,
        defaultValue: defaultPage,
        onChange: onPageChange,
        size: pageSize,
        onSizeChange: onPageSizeChange,
        total: total,
        props: paginationProps
      };
    }

    if (propPaginationOptions) {
      return {
        process: internalProcess
      };
    }

    return undefined;
  }, [internalProcess, propPaginationOptions, pager]);

  var _useTablePaginationIn = useTablePaginationInit(current, paginationOptions),
      _useTablePaginationIn2 = _slicedToArray(_useTablePaginationIn, 3),
      pagedRows = _useTablePaginationIn2[0],
      paginationState = _useTablePaginationIn2[1],
      paginationActions = _useTablePaginationIn2[2];

  current = pagedRows;
  stateRef.current = useMemo(function () {
    var _a, _b;

    return {
      filterState: filterState !== null && filterState !== void 0 ? filterState : {},
      sortState: sortState !== null && sortState !== void 0 ? sortState : [],
      page: (_a = paginationState === null || paginationState === void 0 ? void 0 : paginationState.page) !== null && _a !== void 0 ? _a : 1,
      pageSize: (_b = paginationState === null || paginationState === void 0 ? void 0 : paginationState.size) !== null && _b !== void 0 ? _b : 10
    };
  }, [filterState, sortState, paginationState]);
  var renderColumns = useMemo(function () {
    return columns.map(function (col) {
      return convertColumn(col);
    });
  }, [columns]);

  var _ref2 = paginationOptions || {},
      _ref2$props = _ref2.props;

  _ref2$props = _ref2$props === void 0 ? {} : _ref2$props;
  var _ref2$props$position = _ref2$props.position,
      position = _ref2$props$position === void 0 ? 'bottom' : _ref2$props$position,
      _ref2$props$align = _ref2$props.align,
      align = _ref2$props$align === void 0 ? 'right' : _ref2$props$align;
  var emptyCls = usePrefixCls('table-cell', {
    first: true,
    last: true,
    bottom: props.outerBordered
  });
  var topPagerCls = usePrefixCls('table-pager', _defineProperty({
    top: true
  }, align, true));
  var bottomPagerCls = usePrefixCls('table-pager', _defineProperty({
    bottom: true
  }, align, true));
  var footerCls = classnames(usePrefixCls('table-footer', {
    bordered: extra.bordered,
    'outer-bordered': extra.outerBordered
  }), footerClassName);

  var getFooter = function getFooter() {
    return React.createElement(Fragment, null, typeof footer === 'function' && React.createElement("div", {
      className: footerCls,
      style: footerStyle
    }, footer(data)));
  };

  var content = function content() {
    return React.createElement(Fragment, null, React.createElement(Body, {
      borderTop: noHeader,
      className: classnames(bodyClassName, footer ? 'has-footer' : ''),
      style: _objectSpread(_objectSpread({}, bodyStyle), {}, {
        maxHeight: fixedHeader ? scroll === null || scroll === void 0 ? void 0 : scroll.y : undefined,
        overflowY: fixedHeader ? 'auto' : undefined
      })
    }, React.createElement(RowGroup, {
      rowClassName: rowClassName,
      onRow: onRow,
      rowInfos: current
    })), React.createElement(ScrollerBar, {
      fixed: true
    }));
  };

  var empty = function empty() {
    var emptyInner = React.createElement(Empty, {
      content: emptyText == null ? defaultEmptyText : emptyText
    });
    var emptyContent = renderEmptyCallback();

    if (emptyContent) {
      emptyInner = React.createElement(Empty, null, emptyContent);
    }

    return React.createElement("div", {
      className: emptyCls
    }, emptyInner);
  };

  return React.createElement(PureTable, _objectSpread(_objectSpread({
    columns: renderColumns,
    rowKey: getId
  }, extra), {}, {
    fixedScrollBar: true
  }), React.createElement(TableContextProvider, {
    original: original,
    current: current,
    columns: columns,
    treeActive: treeActive,
    treeActions: treeActions,
    expansionActive: expansionActive,
    expansionActions: expansionActions,
    selected: selected,
    selectionActions: selectionActions,
    filterState: filterState,
    filterActions: filterActions,
    sortState: sortState,
    sortActions: sortActions,
    paginationState: paginationState,
    paginationActions: paginationActions
  }, !!paginationState && !!paginationActions && !!paginationOptions && position !== 'bottom' && React.createElement("div", {
    className: topPagerCls
  }, React.createElement(Pager, _objectSpread(_objectSpread({}, paginationOptions.props), {}, {
    page: paginationState.page,
    pageSize: paginationState.size,
    total: paginationState.total,
    onPageChange: paginationActions.setPage,
    onPageSizeChange: function onPageSizeChange(p, s) {
      paginationActions.setPage(p);
      paginationActions.setSize(s);
    }
  }))), !noHeader && React.createElement(Head, _objectSpread(_objectSpread({}, onHead && onHead() || {}), {}, {
    fixed: fixedHeader
  })), current.length ? content() : empty(), getFooter(), !!paginationState && !!paginationActions && !!paginationOptions && position !== 'top' && React.createElement("div", {
    className: bottomPagerCls
  }, React.createElement(Pager, _objectSpread(_objectSpread({}, paginationOptions.props), {}, {
    page: paginationState.page,
    pageSize: paginationState.size,
    total: paginationState.total,
    onPageChange: paginationActions.setPage,
    onPageSizeChange: function onPageSizeChange(p, s) {
      paginationActions.setPage(p);
      paginationActions.setSize(s);
    }
  })))));
}